import React from "react";
import "./WarningModal.css";
import { Modal } from "react-bootstrap";
import alert from "../../../../assets/images/packages/svg/warning.svg";
import hotel from "../../../../assets/images/packages/svg/hotel.svg";
import flight from "../../../../assets/images/packages/svg/flight.svg";
import transportation from "../../../../assets/images/packages/svg/bus.svg";
import activity from "../../../../assets/images/packages/svg/mountain.svg";
import service from "../../../../assets/images/packages/svg/services.svg";
import dayjs from "dayjs";
import { useTranslation } from "../../../../contexts/TranslationContext";
import Cookies from "js-cookie";

const WarningModal = ({
  showWanings,
  bookWarnings,
  handleClose,
  handleDeleteWithSave,
}) => {
  const { t } = useTranslation();
  const Lang = Cookies.get("preferred_language") || "en";

  return (
    <Modal
      show={showWanings}
      onHide={handleClose}
      centered
      className={`warning-modal ${Lang === "ar" ? "rtl" : "ltr"}`}
    >
      <Modal.Body className="warning-modal-body">
        <div className="icon-wrapper">
          <img src={alert} alt="alert" />
        </div>
        <div className="title">{t("ImportantNotice")}</div>
        <p className="subtitle">{t("YouAlreadyHaveBookings")}</p>

        <div className="booking-info">
          {bookWarnings.map((item, index) => (
            <p>
              <img
                src={
                  item.package_component_type === "Hotel" ||
                  item.package_component_type === "Hotel Reservation"
                    ? hotel
                    : item.package_component_type === "Flight" ||
                      item.package_component_type === "Flight Reservation"
                    ? flight
                    : item.package_component_type === "Transportation"
                    ? transportation
                    : item.package_component_type === "Service"
                    ? service
                    : activity
                }
                className="icon"
                alt="icon"
              />{" "}
              {
              item.package_component_type==="All Time Activity"? t("ReservedActivity") 
              :item.package_component_type==="Hotel" || item.package_component_type==="Hotel Reservation"? t("ReservedHotel") 
              :item.package_component_type==="Flight" || item.package_component_type==="Flight Reservation"? t("ReservedFlight") 
              :item.package_component_type==="Service"? t("ReservedService") 
              :t("ReservedTransportation") 
              } 
             {" "}{t("In")}{" "}
              <strong>
                {item.package_component_type === "Flight" ||
                item.package_component_type === "Flight Reservation"
                  ? item.to_destination_name
                  : item.from_destination_name}
              </strong>{" "}
              {item.date_from ? t("From") : ""}{" "}
              <strong>
                {item.date_from ? dayjs(item.date_from).format("MMM D") : null}
              </strong>{" "}
              {item.date_to ? t("To") : ""}{" "}
              <strong>
                {item.date_to ? dayjs(item.date_to).format("MMM D") : null}
              </strong>
            </p> //row <strong>{item.row_id}</strong>
          ))}
        </div>

        <hr />

        <div className="note-section">
          <div>{t("BookNote")}</div>
          <div>{t("YouCan")}:</div>
          <ul>
            <li>{t("AdjustBookingDates")}</li>
            <li>{t("OrCancelExistingBooking")}</li>
          </ul>
          <div>
            <strong>{t("Note")}:</strong> {t("NotUpdatingBooking")}
          </div>
          <div>
            <strong>{t("Note")}:</strong> {t("ChangeReservationStep")}
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn-ok" onClick={handleDeleteWithSave}>
            {t("RemoveAndSave")}
          </button>
          <button className="btn-cancel" onClick={handleClose}>
            {t("Cancel")}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WarningModal;
